import { Link } from "react-router-dom";
import { ClipboardCheck, AlertTriangle } from "lucide-react";
import { daysUntilLock } from "../lib/planLock";

export default function ProgramStatusPanel({ overview }) {
  const missing = overview.flatMap((cls) =>
    cls.subjects
      .filter((s) => s.progress.total === 0)
      .map((s) => ({ cls: cls.class, subject: s.subject, teacher: s.teacher, assignmentId: s.assignment_id }))
  );
  const total = overview.reduce((acc, c) => acc + c.subjects.length, 0);
  const daysLeft = daysUntilLock();

  if (total === 0) return null;

  if (missing.length === 0) {
    return (
      <div className="mt-8 bg-[var(--ok)]/8 border border-[var(--ok)]/30 px-5 py-4 flex items-center gap-3" data-testid="program-status-panel">
        <ClipboardCheck size={18} className="text-[var(--ok)]" />
        <span className="text-sm">
          <span className="font-medium">Programmes prévisionnels : </span>
          les {total} programmes (matière × classe) sont saisis. Prêt pour la rentrée.
        </span>
      </div>
    );
  }

  return (
    <div className="mt-8 bg-[var(--just)]/10 border border-[var(--just)]/40 px-5 py-4" data-testid="program-status-panel">
      <div className="flex items-center gap-3">
        <AlertTriangle size={18} className="text-[var(--just)]" />
        <span className="text-sm">
          <span className="font-medium">Programmes prévisionnels : </span>
          {missing.length} programme{missing.length > 1 ? "s" : ""} sur {total} non saisi{missing.length > 1 ? "s" : ""} — les professeurs concernés doivent entrer leurs chapitres avant la rentrée.
          {daysLeft > 0 && (
            <span className="font-bold text-[var(--late)]" data-testid="plan-lock-countdown"> Verrou dans {daysLeft} jour{daysLeft > 1 ? "s" : ""} (date butoir : lundi 21 septembre inclus).</span>
          )}
        </span>
      </div>
      <div className="mt-3 flex flex-wrap gap-2">
        {missing.map((m) => (
          <Link
            key={m.assignmentId}
            to={`/admin/assignment/${m.assignmentId}`}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white border border-[var(--parchment-2)] hover:border-[var(--maroon)] text-xs transition-colors"
            data-testid={`missing-program-${m.assignmentId}`}
          >
            <span className="font-medium">{m.cls.name}</span>
            <span className="text-[var(--ink-soft)]">· {m.subject.name} · {m.teacher.name}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
